@let teachingRow = row();

<div
  class="flex items-center gap-4 p-4 bg-base-200 min-h-[100px]"
  [class.opacity-50]="isDimmed()"
  [class.opacity-100]="!isDimmed()"
>
  <div class="flex flex-col gap-2 flex-1 min-w-0">
    <div class="flex items-center gap-2 flex-wrap">
      <span class="type-entity-name flex-1">{{ teachingRow.displayName }}</span>

      <div class="flex flex-reverse gap-2">
        @if (teachingRow.isLearned) {
          <span class="badge badge-sm badge-success">Learned</span>
        }

        <span
          class="badge badge-sm"
          [class.badge-data]="teachingRow.meetsLevel"
          [class.badge-error]="!teachingRow.meetsLevel"
        >
          Lv. {{ teachingRow.teaching.requiredLevel | number }}
        </span>
      </div>
    </div>

    <div class="flex items-center gap-2 min-h-[32px]">
      <div class="flex-1">
        @if (teachingRow.isRevealed) {
          <app-row-stat-summary
            layout="row"
            [stats]="teachingRow.stats"
            [combatStats]="teachingRow.combatStats"
            [resistances]="teachingRow.resistances"
            [monsterTypeDamage]="teachingRow.monsterTypeDamage"
            [elementalResistances]="teachingRow.elementalResistances"
            [elementalBoons]="teachingRow.elementalBoons"
          />

          @let context = skillContext();
          @for (skill of teachingRow.grantedSkills; track skill.id) {
            <app-tooltip-skill-preview
              #preview
              [display]="skill"
              [displayCombatant]="context.combatant"
              [displayCharacterWeaponTypes]="context.weaponTypes"
            />

            <div
              class="flex items-center gap-2 text-xs"
              [tp]="preview.template()"
              [tpPlacement]="'left'"
            >
              <div class="zoom-inline">
                <app-slot-rarity-outline [entry]="skill" spritesheet="skill" />
              </div>
              <span>Learn {{ skill.name }}</span>
            </div>
          }
        } @else if (showRequirements()) {
          <div class="flex flex-wrap items-center gap-2 text-xs">
            <span class="text-lighter">Requires:</span>

            @for (prerequisite of unmetPrerequisites(); track $index) {
              <span class="text-error">{{ prerequisite.name }}</span>
            }

            @for (
              collectible of missingCollectibles();
              track collectible.collectibleId
            ) {
              <div class="flex items-center gap-2 text-error">
                @if (collectible.content; as content) {
                  <div class="zoom-inline">
                    <app-slot-rarity-outline
                      [entry]="content"
                      spritesheet="collectible"
                    />
                  </div>
                  <span>{{ content.name }}</span>
                }
              </div>
            }
          </div>
        }
      </div>

      <div>
        <ng-content select="[actionslot]"></ng-content>
      </div>
    </div>
  </div>
</div>
